import React from 'react';
import { UseChatReturn } from '@varos/assistant-react-chat';
import { Message } from '@varos/assistant-sdk';

interface UseFlushEnqueuedMessagesProps {
    enqueuedMessages: Array<Pick<Message, 'context' | 'parts'> & { idempotencyKey: string }> | null;
    thread: string | null;
    chat: UseChatReturn;
    onClearEnqueuedMessages: () => void;
}
export function createFlushMessagesHook() {
    let enqueuedMessagesLockSet = new Set<string>();
    return function useFlushEnqueuedMessages({
        enqueuedMessages,
        thread,
        chat,
        onClearEnqueuedMessages,
    }: UseFlushEnqueuedMessagesProps) {
        const isFlushing = React.useRef(false);
        const enqueuedMessagesLockSetRef = React.useRef<Set<string>>(enqueuedMessagesLockSet);

        const flushEnqueuedMessages = React.useCallback(async () => {
            if (enqueuedMessages && !isFlushing.current) {
                isFlushing.current = true;
                // console.log('enqueuedMessages !!!', enqueuedMessages);
                let anyEnqueued = false;
                try {
                    for (const message of enqueuedMessages) {
                        if (enqueuedMessagesLockSetRef.current.has(message.idempotencyKey)) {
                            continue;
                        }
                        enqueuedMessagesLockSetRef.current.add(message.idempotencyKey);
                        console.log('enqueuedMessage', message.idempotencyKey, 'flushing');
                        await chat.append(message);
                        anyEnqueued = true;
                        console.log('enqueuedMessage', message.idempotencyKey, 'flushed');
                    }
                } finally {
                    isFlushing.current = false;
                    if (anyEnqueued) {
                        onClearEnqueuedMessages();
                    }
                }
            }
        }, [enqueuedMessages, chat, onClearEnqueuedMessages]);

        React.useEffect(() => {
            flushEnqueuedMessages().finally(() => {
                // limit the size of enqueued messages lock set to 100
                if (enqueuedMessagesLockSetRef.current.size > 100) {
                    enqueuedMessagesLockSet = new Set(
                        Array.from(enqueuedMessagesLockSetRef.current).slice(0, 100)
                    );
                    enqueuedMessagesLockSetRef.current = enqueuedMessagesLockSet;
                }
                console.log('flushEnqueuedMessages finished');
            });
        }, [thread, enqueuedMessages, flushEnqueuedMessages]);
    }
}